import { WebPlugin } from '@capacitor/core';
export class SecureShareWeb extends WebPlugin {
    save(data) {
        console.log(data);
        throw this.unimplemented('Not implemented on web.');
    }
    retrieve() {
        throw this.unimplemented('Not implemented on web.');
    }
    retrieveFrom(data) {
        console.log(data);
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map